import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';
import { authAPI } from '../services/api';
import toast from 'react-hot-toast';
import type { AuthUser } from '../types';

interface AuthCtx {
  user: AuthUser | null;
  loading: boolean;
  login: (email: string, password: string) => Promise<void>;
  logout: () => void;
}

const Ctx = createContext<AuthCtx | null>(null);

export function AuthProvider({ children }: { children: ReactNode }) {
  const [user,    setUser]    = useState<AuthUser | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const stored = localStorage.getItem('tkn_user');
    if (stored) { try { setUser(JSON.parse(stored)); } catch { /**/ } }
    setLoading(false);
  }, []);

  const login = async (email: string, password: string) => {
    const res = await authAPI.login(email, password);
    const { token, user: u } = res.data;
    localStorage.setItem('tkn_token', token);
    localStorage.setItem('tkn_user',  JSON.stringify(u));
    setUser(u);
    toast.success(`Welcome back, ${u.name.split(' ')[0]}!`);
  };

  const logout = () => {
    localStorage.removeItem('tkn_token');
    localStorage.removeItem('tkn_user');
    setUser(null);
    toast.success('Logged out');
  };

  return <Ctx.Provider value={{ user, loading, login, logout }}>{children}</Ctx.Provider>;
}

export function useAuth() {
  const ctx = useContext(Ctx);
  if (!ctx) throw new Error('useAuth must be inside AuthProvider');
  return ctx;
}
